/* global axios */
import ApiClient from './ApiClient';

class TicketsAPI extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true });
  }

  get({ status = 'open', page = 1 } = {}) {
    return axios.get(this.url, { params: { status, page } });
  }

  summary() {
    return axios.get(`${this.url}/summary`);
  }

  createComment(ticketId, formData) {
    return axios.post(`${this.url}/${ticketId}/comments`, formData);
  }
}

export default new TicketsAPI();
